// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/TermsPage/TermsPage.css
// module id = 979
// module chunks = 0